<template>
    <div id="special-offers-page">

        <!-- Map Section -->
        <section v-if="!loading" class="section-style margin-top-100">
            <div data-aos="fade-left"
                 data-aos-offset="100"
                 data-aos-once="true"
                 data-aos-duration="500">

                <div class="container padding-right-left-0">
                    <h1 class="bd-title section-title default-letter-spacing text-uppercase font-weight-bold font-md text-center">Special Offers</h1>
                </div>

                <!-- Special Offers List -->
                <div class="container padding-right-left-0 margin-top-40">
                    <div class="row justify-content-center">
                        <div class="col-12 col-md-6 col-lg-4" v-for="promotion in promotions">
                            <div class="box-element bg-white box-shadow d-flex flex-column rounded">
                                <div class="box-element-image">
                                    <a @click.prevent="openModal('special-offer', {promotion})" href="/" class="zoom-image rounded-top">
                                        <span class="zoom-image-hover"></span>
                                        <img class="width-100 rounded-top" :src="promotion.picture" alt="'promotion_'+promotion.id+_picture'">
                                    </a>
                                </div>
                                <div class="box-element-info">
                                    <h3 class="font-md">
                                        <a @click.prevent="openModal('special-offer', {promotion})" class="link-style font-weight-bold" href="#">{{ promotion.name }}</a>
                                    </h3>
                                    <p class="margin-top-40 text-justify">
                                        {{ promotion.description | truncate(150) }}
                                    </p>
                                </div>
                                <div class="box-element-link text-center mt-auto">
                                    <a @click.prevent="openModal('special-offer', {promotion})" href="#" class="font-weight-bold font-md link-style">View offer</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </section>

        <loader class="margin-top-120" v-if="loading" :radius="10" :stroke="2"></loader>
    </div>
</template>

<script>
    import Loader from "./../components/misc/Loader"
    import SpecialOfferModal from "./../components/modals/SpecialOfferModal";

    export default {
        components: { Loader },

        created() {
            this.initialize();
        },

        data() {
            return {
                loading: false,
            }
        },
        computed: {
            currentUser() {
                return this.$store.getters["Auth/user"];
            },
            promotions() {
                return this.$store.getters["Data/getPromotions"]();
            }
        },
        methods: {
            async initialize() {
                this.loading = true;

                await this.$store.dispatch("Data/initializeData");

                this.loading = false;
            },

            openModal(modal, props = {}, events = {}) {
                let modalComponent = null;
                let options = {};

                switch (modal)
                {
                    case "special-offer":
                        modalComponent = SpecialOfferModal;
                        options.width = "700px";
                        break;
                }

                this.$modal.show(modalComponent, _.assign({}, props, {showGetQuote: !!this.currentUser}), _.assign({
                    draggable: false,
                    height: 'auto',
                    scrollable: true,
                }, options), events);
            },
        }
    }
</script>


<style lang="scss">

</style>
